<template>
  <div>
    <modal id="delete-article-modal" v-if="selectedArticle.article">
      <h5 slot="header">
        <strong>{{ translations.deleteArticle }}</strong>
      </h5>
      <div slot="body">
        <span v-html="articleModalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="deleteArticle"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <section class="card card-modern card-big-info">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group row align-items-center">
              <div class="col">
                <div class="form-group row pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                  >
                    Pretraga artikala
                  </label>
                  <div class="col-lg-7 col-xl-6 position-relative">
                    <input
                      type="text"
                      class="search-term form-control"
                      placeholder="Pretraga"
                      v-model="searchField"
                      @input="onSearchHandle"
                      @blur="onBlurHandle"
                      @focus="onFocusHandle"
                    />

                    <ul class="article-list bg-body" v-if="showSearchResults">
                      <li
                        v-for="article in articles"
                        :key="article.id"
                        @click="addArticle(article)"
                      >
                        <div class="article-wrapper">
                          <img
                            v-if="article.highlightedImageUrl"
                            :src="`${baseUrl}${article.highlightedImageUrl}`"
                            class="article-image"
                          />

                          <img
                            v-else
                            class="article-image"
                            :src="'img/products/product-8.jpg'"
                          />
                          <div class="article-description">
                            <div class="article-title">
                              {{ article.title }}
                            </div>
                            <div class="article-code">
                              {{ article.code }}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="card card-modern card-big-info">
      <div class="card-body">
        <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-end layout-modes">
                <div
                  class="layout-btn btn-grid"
                  title="Grid"
                  :class="{ active: layout === 'grid' }"
                  @click="layout = 'grid'"
                >
                  <i class="fa fa-th"></i>
                </div>
                <div
                  class="layout-btn btn-list"
                  title="List"
                  :class="{ active: layout === 'list' }"
                  @click="layout = 'list'"
                >
                  <i class="fa fa-th-list"></i>
                </div>
                <div
                  class="layout-btn btn-bars"
                  title="Bars"
                  :class="{ active: layout === 'bars' }"
                  @click="layout = 'bars'"
                >
                  <i class="fas fa-bars"></i>
                </div>
              </div>
            </div>
        </div>
      </div>

    </section>
    <div v-if="companyArticles.length > 0" class="mt-3">
      <div class="row mt-3" v-if="layout === 'grid'">
        <div class="col-12">
          <div class="row row-gutter-sm">
            <div
              class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 mb-3"
              v-for="item in companyArticles"
              :key="item.article.id"
            >
              <div class="card card-modern card-modern-alt-padding">
                <div class="card-body bg-light">
                  <div class="image-frame mb-2">
                    <div class="image-frame-wrapper">
                      <div
                        class="remove-item"
                        @click.stop.prevent="confirmDeleteModal(item)"
                      >
                        <i class="bx bx-x"></i>
                      </div>
                      <div>
                        <photo
                          :src="'img/products/product-8.jpg'"
                          v-if="!item.article.highlightedImageUrl"
                        />
                        <photo
                          :src="`${baseUrl}${item.article.highlightedImageUrl}`"
                          v-else
                        />
                      </div>
                    </div>
                  </div>
                  <small>
                    <div class="text-hidden" :title="item.article.category">
                      {{ item.article.category }}
                    </div>
                  </small>
                  <h4 class="text-4 line-height-2 mt-0 mb-2">
                    <router-link
                      class="ecommerce-sidebar-link text-color-dark text-color-hover-primary text-decoration-none text-hidden"
                      :title="item.article.title"
                      :to="{
                        name: 'EditArticle',
                        params: { id: item.article.id },
                      }"
                    >
                      {{ item.article.title }}
                    </router-link>

                    <div>
                      {{ item.article.code }}
                    </div>
                  </h4>
                  <div class="stars-wrapper">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                  </div>
                  <div class="product-price">
                    <div class="sale-price">{{ item.price | money2 }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row row-sm" v-if="layout === 'list'">
        <div
          class="col-6 col-sm-12 product-default left-details product-list"
          v-for="item in companyArticles"
          :key="item.id"
        >
          <figure>
            <router-link :to="{ name: 'Article', params: { id: item.id } }">
              <img :src="`${baseUrl}${item.article.highlightedImageUrl}`" />
            </router-link>
          </figure>
          <div class="product-details product-details-list">
            <div class="category-list">
              <router-link
                v-if="item.article.brandId"
                class="product-category"
                :to="{ name: 'EditBrand', params: { id: item.article.brandId } }"
              >
                {{ item.article.brand }}
              </router-link>
              <span
                v-else
                class="product-category"
              >
                {{ item.article.brand }}
              </span>
            </div>
            <h2 class="product-title">
              <router-link :to="{ name: 'EditArticle', params: { id: item.article.id } }">
                {{ item.article.title }}
              </router-link>
            </h2>
            <div class="ratings-container">
              Šifra: {{ item.article.code }}
              <!-- End .product-ratings -->
            </div>
            <!-- End .product-container -->
            <p class="product-description">
              {{ item.article.description }}
            </p>
            <div class="price-box">
              <span class="product-price">{{ item.price | money2 }}</span>
            </div>
            <!-- End .price-box -->
          </div>
          <!-- End .product-details -->
        </div>
      </div>
      
      <div
        class="bg-white table-product-list"
        v-if="layout === 'bars'"
      >
        <table class="table text-left">
          <thead>
              <tr>
                  <th>Proizvođač</th>
                  <th>Šifra</th>
                  <th>Naziv proizvoda</th>
                  <th>Pregled</th>
                  <th>Cijena</th>
              </tr>
          </thead>
          <tbody>
            <tr v-for="item in companyArticles" :key="item.id">
              <td>
                <router-link
                  v-if="item.article.brandId"
                  class="product-category"
                  :to="{ name: 'EditBrand', params: { id: item.article.brandId } }"
                >
                  {{ item.article.brand }}
                </router-link>
                <span v-else>
                  N/A
                </span>
              </td>
              <td>
                {{ item.article.code }}
              </td>
              <td>
                <router-link :to="{ name: 'EditArticle', params: { id: item.id } }">
                  {{ item.article.title }}
                </router-link>
              </td>
              <td>
                <img
                  class="small-product-list-img"
                  :src="`${baseUrl}${item.article.highlightedImageUrl}`"
                />
              </td>
              <td>
                <span>{{ item.price | money2 }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from "lodash";
import api from "@/services/api";
import config from "@/config";

import Modal from "../shared/modal/Modal.vue";
import Photo from "../shared/Photo.vue";

import { translations } from "@/mixins";

export default {
  name: "CompanyArticles",
  mixins: [translations],
  components: { Photo, Modal },
  data() {
    return {
      searchField: "",
      showSearchResults: false,
      baseUrl: config.baseUrl,
      selectedArticle: {},
      layout: 'grid',
    };
  },
  computed: {
    articles() {
      return this.$store.getters.getArticles;
    },
    companyArticles() {
      return this.$store.getters.getCompanyArticles;
    },
    articleModalText() {
      return this.selectedArticle.article
        ? this.translations.areYouSureArticle.replace(
            "{article}",
            `<strong>${this.selectedArticle.article.title}</strong>`
          )
        : "";
    },
  },
  methods: {
    onSearchHandle: debounce(function () {
      this.showSearchResults = true;
      this.$store.dispatch("getArticles", {
        sortBy: "title",
        isSortAscending: true,
        page: 1,
        pageSize: 5,
        quickSearch: this.searchField.trim(),
      });
    }, 300),
    onFocusHandle() {
      if (this.searchField) {
        this.showSearchResults = true;
      }
    },
    onBlurHandle() {
      debounce(function () {
        this.showSearchResults = false;
      }, 300);
    },
    addArticle(article) {
      const payload = {
        companyId: parseInt(this.$route.params.id, 10),
        articleId: article.id,
      };

      api
        .createCompanyArticlePrice(payload)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .finally(() => {
          this.$store.dispatch("getCompanyArticles", this.$route.params.id);
        });
      this.showSearchResults = false;
      this.searchField = "";
    },
    confirmDeleteModal(article) {
      this.selectedArticle = article;
      const timer = setTimeout(() => {
        $("#delete-article-modal").modal("show");
        clearTimeout(timer);
      });
    },
    updateArticlePrice(article) {
      api
        .updateCompanyArticlePrice(article)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .finally(() => {
          this.$store.dispatch("getCompanyArticles", this.$route.params.id);
          $("#edit-article-price").modal("hide");
        });
    },
    deleteArticle() {
      api
        .deleteCompanyArticle(this.selectedArticle.id)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .finally(() => {
          this.$store.dispatch("getCompanyArticles", this.$route.params.id);
          $("#delete-article-modal").modal("hide");
        });
    },
  },
  mounted() {
    this.$store.dispatch("getCompanyArticles", this.$route.params.id);
  },
};
</script>
<style lang="scss">
@import "../articles/assets/scss/linked-articles.scss";
.text-hidden {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}

.image-frame-wrapper {
  position: relative;

  .remove-item {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 1.5rem;
    cursor: pointer;
  }
}

.layout-modes {
  div {
    margin-left: 10px;
  }

  .layout-btn {
    cursor: pointer;

    &.active {
      color: #1E84BC;
    }
  }
}

.product-default:hover {
  z-index: 1;
  box-shadow: 0 12px 20px 0 rgb(0 0 0 / 8%);
  transition: box-shadow 0.3s ease-in-out;
}

.product-list:hover {
  box-shadow: none;
}

.product-details {
  background: white;
  padding: 5px;
}

.product-list {
  display: flex;

  figure {
    max-width: 270px;
    margin-right: 20px;
    margin-bottom: 0;

    img {
      object-fit: cover;
      height: 100%;
    }
  }

  .product-details {
    width: 100%;

    .product-title {
      color: #777;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .product-title {
    font-size: 18px;
    font-weight: 600;
    color: #777;

    a {
      color: #777;
    }
  }

  .product-description {
    font : 400 1.4rem;
    line-height: 24px;
    margin-bottom: 1em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-width: 100%;
  }

  .btn-icon-wish,
  .btn-quickview {
    opacity: 1;
    background-color: #fff;
    color: #333;
    border-color: #dddddd;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  &:hover {
    figure {
      box-shadow: none;
    }
  }
}

.product-widget {
  display: flex;
  margin-bottom: 15px;

  figure {
    max-width: 84px;
    margin-right: 20px;
    margin-bottom: 0;

    img {
      object-fit: cover;
      height: 100%;
    }
  }

  .ratings-container {
    margin-bottom: 5px;
  }

  .product-details {
    max-width: calc(100% - 104px);
  }

  .product-title {
    font-size: 1.4rem;
  }

  .price-box {
    margin-bottom: 0;
  }

  .product-price {
    font-size: 1.5rem;
  }

  .old-price {
    font-size: 1.2rem;
  }

  &:hover figure {
    box-shadow: none;
  }
}

.small-product-list-img {
  height: 40px;
}

.product-default figure img {
  transition: all .5s;
  height: auto;
  width: 100%;
}

.product-list {
  margin-bottom: 1rem;
}

.product-list figure img {
  object-fit: cover;
  height: 100%;
}

.product-default figure img {
  height: auto;
}

.product-default figure img:last-child {
  opacity: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  left: 0;
}

.product-default figure img:first-child {
  opacity: 1;
  position: relative;
}

.product-price {
  color: #465157;

  font-weight: 600;
  font-size: 18px;
  opacity: 0.8;
}

.product-default .product-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.product-details-list {
  margin-top: unset;
  padding: 0 15px;
}

</style>
